// extracted by mini-css-extract-plugin
export default {"migrationBanner":"XNfvTQAo30GDhAhUAda5"};